export default "__VITE_ASSET__8xSSh47A__"